module.exports = __webpack_public_path__ + "static/media/reqa.460dfcd5.jpeg";